import { FC, PropsWithChildren } from 'react';

import { Container } from '@shared/ui/Container';

import cls from './SeoText.module.scss';

export const SeoText: FC<PropsWithChildren> = ({ children }) => {
  return <Container className={cls.wrapper}>{children}</Container>;
};
